module.exports = __webpack_public_path__ + "img/wenhua (2).c21f3ab2.png";